export default "__VITE_ASSET__CbpIoNRB__"